import {Editor, EditorProps} from "../Editor/Editor";
import {createStyles, useMantineTheme} from "@mantine/core";
import {useCallback, useRef} from "react";


export type EditorInputProps = Omit<EditorProps, 'theme'> & {
  // extend props here
}

const useStyles = createStyles((theme) => ({
  editorWrapper: {
    border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[4]}`,
    borderRadius: theme.radius.md,
    padding: theme.spacing.sm,
    overflow: 'hidden',
    '&:focus-within': {
      borderColor: theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6],
    },
  },
}));

export const EditorInput = (props: EditorInputProps) => {
  const {onMount, ...rest} = props;

  const theme = useMantineTheme();
  const {classes} = useStyles();

  const editorRef = useRef(null)

  const handleEditorDidMount = useCallback((editor, monaco) => {
    editorRef.current = editor
    setTimeout(() => {
      editor.getAction('editor.action.formatDocument').run();
    }, 100);

    if (onMount) {
      onMount(editor, monaco)
    }
  }, [onMount])

  return (
    <div className={classes.editorWrapper}>
      <Editor
        {...rest}
        onMount={handleEditorDidMount}
        theme={theme.colorScheme === 'dark' ? 'vs-dark' : 'light'}
      />
    </div>
  )
}
